import type { MeProfile } from '@/api/services/me';

/** Show workspace/team admin nav only when the user manages a multi-user workspace. */
export function canViewWorkspaceNav(me: MeProfile | null | undefined): boolean {
  if (!me) return false;
  if (me.permissions.canViewSystemDashboard) return true;
  if ((me.workspaceCount ?? 1) > 1) return true;
  if (me.permissions.canManageUsers) return true;
  return false;
}
